import { inAndroid, inIOS } from 'vtils'

const isVConsole = inIOS() || inAndroid()

export function logg(title: string, data: any) {
  console.log(
    `%c${isVConsole ? ' ' : ''}${title} · 日志`,
    `
      background: linear-gradient(131deg, #64e669 0%, #39b43e 100%);
      color: #ffffff;
      padding: 4px 8px;
      border-radius: 4px;
      line-height: 1;
      white-space: nowrap;
      margin-bottom: 4px;
    `,
    `${isVConsole ? '\n' : ''}\n日志数据：`,
    data,
  )
}
